'use client';

import type { FC, JSX } from 'react';
import React, { useMemo } from 'react';
import type { MagnoliaImageContent } from '@/types/cms/magnolia';
import { mapToApiImage } from '@/Util/globals';
import { isMagnoliaImages } from '@/types/typeGuards';
import ImageGalleryInner from '@/components/imageGallery/ImageGalleryInner';
import type { ApiImage } from '../../../api/model';
import type { ImageGalleryProps } from '@/components/imageGallery/ImageGalleryProps';
import { TFunction } from 'i18next';
import Keys from '@/Translations/generated/da/product.json.keys';
import { useTranslation } from '@/app/i18n/client';

const labelMapper = (t: TFunction): Record<string, string> => {
  return {
    MAPPER_PRODUCT_GALLERY: t(Keys.gallery)
  };
};

const ImageGallery: FC<ImageGalleryProps> = (props: ImageGalleryProps): JSX.Element => {
  const { t } = useTranslation('product');
  const { theme, headline, images, h2Headline, pageProps } = props;

  const transformedImages = useMemo((): ApiImage[] => {
    return isMagnoliaImages(images)
      ? (images['@nodes'].map(node =>
          mapToApiImage(
            images[node as keyof MagnoliaImageContent].image,
            images[node as keyof MagnoliaImageContent].image.metadata.caption
          )
        ) as ApiImage[])
      : images;
  }, []);

  return (
    <>
      {!!transformedImages && (
        <ImageGalleryInner
          images={transformedImages}
          theme={theme}
          headline={headline?.startsWith('MAPPER_') ? labelMapper(t)[headline] : headline}
          h2Headline={h2Headline}
          pageProps={pageProps}
        />
      )}{' '}
    </>
  );
};

export default ImageGallery;
